import CanvaDesign from '@core/lib/admin/components/canva_design'
import PropTypes from 'prop-types'
import React from 'react'

class CanvaDesignWrapper extends React.Component {

  static propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return <CanvaDesign { ...this._getCanvaDesign()} />
  }
  
  _getCanvaDesign() {
    const { onBack } = this.props
    return {
      onBack,
      onDone: this._handleDone
    }
  }

  _handleDone(canva_design) {
    const { assets, title } = canva_design
    this.props.onNext({
      title,
      type: 'photo',
      canva_template: {
        entity: {
          content: {
            photos: assets.map(asset => ({ 
              photo: {
                asset_id: asset.id,
                asset,
                transforms: {
                  crop: {
                    l: 0,
                    t: 0,
                    w: asset.metadata.width,
                    h: asset.metadata.height
                  }
                }
              } 
            }))
          }
        }
      }
    })
  }

}

export default CanvaDesignWrapper

